// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/cob-sticky-cart/" + "cob-sticky-cart.sticky-cart.plugin" + "." + "e79798" + ".js";
};